import { Component, OnInit } from '@angular/core';
import { AgileStudioAuthService } from 'src/app/Services/agile-studio-auth.service';
import { ImportMappedProjectService } from 'src/app/Services/import-mapped-project.service';
import { JiraAuthService } from 'src/app/Services/jira-auth.service';
import { UserService } from 'src/app/Services/user.service';
import { Router } from '@angular/router';
import { NotifyService } from 'src/app/Services/notify.service';

@Component({
  selector: 'ze-map-project',
  templateUrl: './map-project.component.html',
  styleUrls: ['./map-project.component.scss']
})
export class MapProjectComponent implements OnInit {

  constructor(private importMappedProjectService: ImportMappedProjectService, private jiraAuthService: JiraAuthService, private agileStudioAuthService: AgileStudioAuthService, private userService: UserService, private router: Router, private notifyService: NotifyService) { }
  PMProjectListJira: any[] = [];
  PMProjectListAgile: any[] = [];
  selectiveProjectChild: any;
  isFullImportChecked: boolean = false;
  isSelectiveImportChecked: boolean = false;
  activeTab: 'jira' | 'agileStudio';
  isProjectSelected: boolean = false;
  showSuccessMessage = false;
  selectedProject: any = "";
  isImporting: boolean = false;
  selectiveEpic: any[] = [];
  selectiveFeature: any[] = [];
  selectiveScenario: any[] = [];
  childList: any[] = [];
  isLoadingSelectiveData: boolean = false;
  jiraIntegrationAvailable: boolean = false;
  agileStudioIntegrationAvailable: boolean = false;
  users: any[] = [];
  selectedUsers: any[] = [];
  isAssigning: boolean = false;

  MySelectedPayload = {
    licenseId: "",
    project: {} as any,
    epics: {
      epics: []
    },
    scenarios: {
      userStories: []
    }
  }

  ngOnInit() {
    this.importMappedProjectService.getOrgAccNo().subscribe(
      (response: any) => {
        if (response.operationStatus === 'SUCCESS' &&
          response.data &&
          response.data.length > 0) {
          const firstAccount = response.data[0];
          
          this.loadUsers({ accNo: firstAccount.accNo,
          accountId: firstAccount.id 
        });
        }
      } ,
      error => {
      console.error('Error fetching org accounts', error);
    })
    this.isFullImportChecked = true;
    this.checkJiraIntegration();
    this.checkAgileIntegration();
  }

  checkJiraIntegration() {
    this.jiraAuthService.isJiraIntegrationAvailable().subscribe(
      (response: any) => {
        const cloudId = response.data.cloud_id;
        if (cloudId) {
          this.getPMProjectListJira(cloudId);
          this.activeTab = 'jira';
          this.jiraIntegrationAvailable = true;
        } else {
          console.warn('Cloud ID not found in Jira integration response.', cloudId);
        }
      },
      (error) => {
        console.error('Error checking Jira integration:', error);
      }
    );
  }

  checkAgileIntegration() {
    this.agileStudioAuthService.isAgileStudioIntegrationAvailable().subscribe(
      (response: any) => {
        if (response.data) {
          if (this.activeTab == 'jira') {
            this.activeTab = 'jira';
          } else {
            this.activeTab = 'agileStudio';
          }
          this.agileStudioIntegrationAvailable = true;
        } else {
          console.warn('Agile Studio integration not found.', response);
        }
      })
  }

  switchTab(tab: 'jira' | 'agileStudio') {
    this.activeTab = tab;
    if (tab === 'agileStudio') {
      this.getPMProjectList('agileStudio');
    }
  }
  closeSuccessMessage() {
    this.showSuccessMessage = true;
  }

  toggleFullImport() {
    this.isFullImportChecked = true;
    this.isSelectiveImportChecked = false;
  }

  toggleSelectiveImport() {
    this.isSelectiveImportChecked = true;
    this.isFullImportChecked = false;
    if (this.selectedProject) {
      this.isLoadingSelectiveData = true;
      this.importMappedProjectService.importSelectiveMappedProject(this.selectedProject).subscribe(
        (response: any) => {
          this.isLoadingSelectiveData = false;
          this.selectiveEpic = (response && response.epics && response.epics.epics) || [];
          this.selectiveFeature = (response && response.features && response.features.features) || [];
          this.selectiveScenario = (response && response.scenarios && response.scenarios.userStories) || [];
        },
        (error) => {
          console.error('Error importing project:', error);
          this.isLoadingSelectiveData = false;
        }
      );
    }
  }


  getPMProjectList(option: string) {
    this.importMappedProjectService.getPMProjectList("", option).subscribe(
      (response: any) => {
        this.PMProjectListAgile = response.data.Products;
      },
      (error) => {
        console.error('Error fetching project list:', error);
      }
    );
  }

  getPMProjectListJira(cloudId: string) {
    this.importMappedProjectService.getPMProjectList(cloudId, "jira").subscribe(
      (response: any) => {
        this.PMProjectListJira = response.data.Boards;
      },
      (error) => {
        console.error('Error fetching project list:', error);
      }
    );
  }

  importAllMappedProject(data: any) {
    const storedLicenseId = localStorage.getItem('licenseId');
    // Treat explicit "null" or missing value as no license scenario
    const licenseId = storedLicenseId && storedLicenseId !== 'null' ? storedLicenseId : null;
    
    this.isImporting = true;
    this.showSuccessMessage = false;
    this.importMappedProjectService.importAllMappedProject(data, licenseId).subscribe(
      (response: any) => {
        this.showSuccessMessage = true;
        this.selectiveProjectChild = response;
        this.isImporting = false;
        if (response && response.data) {
          localStorage.setItem('projectId', response.data);
        }
      },
      (error) => {
        this.isImporting = false;
        this.showSuccessMessage = false;
        console.error('Error importing project:', error);
      }
    );
  }

  importSelectiveMappedProject(data: any) {
    this.importMappedProjectService.importSelectiveMappedProject(data).subscribe(
      (response: any) => {
        this.selectiveEpic = (response && response.epics && response.epics.epics) || [];
        this.selectiveFeature = (response && response.features && response.features.features) || [];
        this.selectiveScenario = (response && response.scenarios && response.scenarios.userStories) || [];
        this.selectiveEpic = this.selectiveEpic.map((epic, index) => ({
          ...epic,
          id: `epic-${index}`,
          type: 'epic',
          selected: false,
          children: []
        }));

        this.selectiveFeature = this.selectiveFeature.map((feature, index) => ({
          ...feature,
          id: `feature-${index}`,
          type: 'feature',
          selected: false,
          children: []
        }));

        this.selectiveScenario = this.selectiveScenario.map((scenario, index) => ({
          ...scenario,
          id: `scenario-${index}`,
          type: 'scenario',
          selected: false
        }));
        this.isLoadingSelectiveData = false;
      },
      (error) => {
        console.error('Error importing project:', error);
        this.isLoadingSelectiveData = false;
      }
    );
  }

  onProjectSelect() {
    this.isProjectSelected = !!this.selectedProject;

    if (this.selectedProject) {
      if (!this.isSelectiveImportChecked) {
        this.isFullImportChecked = true;
      }

      this.isLoadingSelectiveData = true;
      this.selectiveEpic = [];
      this.selectiveFeature = [];
      this.selectiveScenario = [];


      this.MySelectedPayload.project = {
        project_management_project_id: this.selectedProject.project_management_project_id,
        projectName: this.selectedProject.projectName,
        project_management_project_key: this.selectedProject.project_management_project_key,
        project_style: this.selectedProject.project_style,
        projectTypeKey: this.selectedProject.projectTypeKey || 'software',
        project_management_type: this.selectedProject.project_management_type,
        todo: this.selectedProject.todo || 'To Do',
        inProgress: this.selectedProject.inProgress || 'In Progress',
        done: this.selectedProject.done || 'Done',
        codeReview: this.selectedProject.codeReview || 'CodeReview'
      };


      if (this.isSelectiveImportChecked) {
        this.importMappedProjectService.importSelectiveMappedProject(this.selectedProject).subscribe(
          (response: any) => {
            this.isLoadingSelectiveData = false;
            this.selectiveEpic = (response && response.epics && response.epics.epics) || [];
            this.selectiveFeature = (response && response.features && response.features.features) || [];
            this.selectiveScenario = (response && response.scenarios && response.scenarios.userStories) || [];

            this.selectiveEpic = this.selectiveEpic.map((epic, index) => ({
              ...epic,
              id: `epic-${index}`,
              type: 'epic',
              selected: false,
              children: []
            }));

            this.selectiveFeature = this.selectiveFeature.map((feature, index) => ({
              ...feature,
              id: `feature-${index}`,
              type: 'feature',
              selected: false,
              children: []
            }));

            this.selectiveScenario = this.selectiveScenario.map((scenario, index) => ({
              ...scenario,
              id: `scenario-${index}`,
              type: 'scenario',
              selected: false
            }));
          },
          (error) => {
            console.error('Error fetching project data:', error);
            this.isLoadingSelectiveData = false;
          }
        );
      }
    }
  }

  onEpicCheckboxChange(event: any, epic: any) {
    if (event.target.checked) {
      const alreadyExists = this.MySelectedPayload.epics.epics.some(
        (e: any) => e.epic_id === epic.epic_id
      );

      if (!alreadyExists) {
        this.MySelectedPayload.epics.epics.push({
          epic_id: epic.epic_id,
          epic_key: epic.epic_key,
          epic_name: epic.epic_name,
          epicStatus: epic.epicStatus,
          _type:epic._type,
          project_management_type: epic.project_management_type,
          epic_created_time: epic.epic_created_time
        });
      }

      this.importMappedProjectService.childSelect(epic, this.selectedProject).subscribe(
        (response: any) => {
          const children = (
            response &&
            response.data &&
            response.data.scenarios &&
            response.data.scenarios.userStories
          ) || [];

          epic.children = children.map((child: any) => {
            child.selected = true;

            const alreadyChildExists = this.MySelectedPayload.scenarios.userStories.some(
              (s: any) => s.issue_id === child.issue_id
            );

            if (!alreadyChildExists) {
              this.MySelectedPayload.scenarios.userStories.push({
                issue_id: child.issue_id,
                issue_key: child.issue_key,
                issue_summary: child.issue_summary,
                issue_created_time: child.issue_created_time,
                project_management_type: child.project_management_type,
                issue_type: child.issue_type,
                project_management_project_id: child.project_management_project_id,
                projectName: child.projectName,
                status: child.status || '',
                parent_id: child.parent_id,
                parent_type: child.parent_type
              });
            }
            return child;
          });
        }
      );
    } else {
      epic.selected = false;
      epic.children = [];

      this.MySelectedPayload.epics.epics = this.MySelectedPayload.epics.epics.filter(
        (e: any) => e.epic_id !== epic.epic_id
      );

      this.MySelectedPayload.scenarios.userStories = this.MySelectedPayload.scenarios.userStories.filter(
        (s: any) => s.parent_id !== epic.epic_id
      );
    }
  }


  onFeatureCheckboxChange(event: any, feature: any) {
    if (event.target.checked) {
      this.importMappedProjectService.childSelectfeature(feature, this.selectedProject).subscribe(
        (response: any) => {
          feature.children = response.data.scenarios.userStories;
        })
    } else {
      feature.children = [];
    }
  }

  onScenarioCheckboxChange(event: any, scenario: any) {
    if (event.target.checked) {
      const alreadyExists = this.MySelectedPayload.scenarios.userStories.some(
        (s: any) => s.issue_id === scenario.issue_id
      );

      if (!alreadyExists) {
        this.MySelectedPayload.scenarios.userStories.push({
          issue_id: scenario.issue_id,
          issue_key: scenario.issue_key,
          issue_summary: scenario.issue_summary,
          issue_created_time: scenario.issue_created_time,
          project_management_type: scenario.project_management_type,
          issue_type: scenario.issue_type,
          project_management_project_id: scenario.project_management_project_id,
          projectName: scenario.projectName,
          status: scenario.status
        });
      }

      this.importMappedProjectService.childSelectscenario(scenario, this.selectedProject).subscribe(
        (response: any) => {
          scenario.children = response.data.scenarios.userStories;
        })
    } else {
      scenario.children = [];
      this.MySelectedPayload.scenarios.userStories = this.MySelectedPayload.scenarios.userStories.filter(
        (s: any) => s.issue_id !== scenario.issue_id
      );
    }
  }

  selectiveImport() {
    this.isImporting = true;
    this.showSuccessMessage = false;
    const storedLicenseId = localStorage.getItem('licenseId');
    // Treat explicit "null" or missing value as no license scenario
    const licenseId = storedLicenseId && storedLicenseId !== 'null' ? storedLicenseId : null;
    this.MySelectedPayload.licenseId = licenseId;
    this.importMappedProjectService.allSelectiveImport(this.MySelectedPayload).subscribe(
      (response: any) => {
        this.isImporting = false;
        this.showSuccessMessage = true;
        if (response && response.data) {
          localStorage.setItem('projectId', response.data);
        }
      },
      (error: any) => {
        this.isImporting = false;
        this.showSuccessMessage = false;
        console.error('Import Error:', error);
      }
    );
  }


  onChildCheckboxChange(event: any, child: any) {
    if (event.target.checked) {
      child.selected = true;

      const alreadyExists = this.MySelectedPayload.scenarios.userStories.some(
        (s: any) => s.issue_id === child.issue_id
      );

      if (!alreadyExists) {
        this.MySelectedPayload.scenarios.userStories.push({
          issue_id: child.issue_id,
          issue_key: child.issue_key,
          issue_summary: child.issue_summary,
          issue_created_time: child.issue_created_time,
          project_management_type: child.project_management_type,
          issue_type: child.issue_type,
          project_management_project_id: child.project_management_project_id,
          projectName: child.projectName,
          status: child.status || '',
          parent_id: child.parent_id,
          parent_type: child.parent_type
        });
      }
    } else {
      child.selected = false;

      this.MySelectedPayload.scenarios.userStories = this.MySelectedPayload.scenarios.userStories.filter(
        (s: any) => s.issue_id !== child.issue_id
      );
    }
  }

  loadUsers(account: { accNo: number; accountId: string }) {
    this.importMappedProjectService.getOrgAccUsers(account.accNo, account.accountId).subscribe(
      (response: any) => {
        this.users = response.data || [];
      },
      (error) => {
        console.error('Error loading users:', error);
      }
    );
  }

  onUserSelect(user: any) {
    const index = this.selectedUsers.findIndex(u => u === user);
    if (index === -1) {
      this.selectedUsers.push(user);
    } else {
      this.selectedUsers.splice(index, 1);
    }
  }

  isUserSelected(user: any): boolean {
    return this.selectedUsers.includes(user);
  }

  assignUsers() {
    if (!this.selectedProject || this.selectedUsers.length === 0) return;

    this.isAssigning = true;

    this.importMappedProjectService.assignJiraProjectToUser(this.selectedUsers).subscribe(
      (response: any) => {
        this.isAssigning = false;
        this.showSuccessMessage = true;
        this.notifyService.notify('success', 'Success', 'Users have been successfully assigned to this project!');
        setTimeout(() => {
          this.router.navigate(['/project']);
        }, 1500);
      },
      (error: any) => {
        this.isAssigning = false;
        console.error('Error assigning users:', error);
        this.notifyService.notify('error', 'Error', 'Failed to assign users. Please try again.');
      }
    );
  }

  skipAssignment() {
    this.router.navigate(['/project']);
  }
}
